export default "__VITE_ASSET__CLix2wAz__"